<div class="widgets-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div *ngIf="audience && audience.parent; else defaultAudienceTitle">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ audience.name | audienceDisplayName }}</h5>
                        <h2>{{ 'ENGAGE.WIDGET.TITLE.PLURAL' | translate }}</h2>
                    </div>
                </div>
            </div>
            <ng-template #defaultAudienceTitle>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name" *ngIf="audience">{{ audience.name | audienceDisplayName }}</h5>
                        <h2>{{ 'ENGAGE.WIDGET.TITLE.PLURAL' | translate }}</h2>
                    </div>
                </div>
            </ng-template>
        </div>
    </mat-toolbar>
    <div class="widgets">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-white p-16 mb-24" *ngIf="audienceRelevantExperiences.length">
            <div fxLayout="row" fxLayoutAlign="start baseline" class="text-truncate pr-12">
                <span class="text-gray-500">{{ 'ENGAGE.AUDIENCE.LABELS.FILTERED_BY_EXPERIENCE' | translate }}:</span>
                <span>&nbsp;</span>
                <span class="text-black text-truncate" *ngFor="let relevantExperience of audienceRelevantExperiences; let last = last">
                    {{ relevantExperience.experience.name }}<span *ngIf="!last">,&nbsp;</span>
                </span>
            </div>

            <div fxLayout="row" fxLayoutAlign="flex-end center" class="pointer" (click)="navigateToChangeExperience()">
                <span class="text-primary-500 mr-4">{{ 'PAGE.ENGAGE.TAB.EXPERIENCE.BUTTONS.CHANGE_EXPERIENCE' | translate }}</span>
                <mat-icon class="text-primary-500">keyboard_arrow_right</mat-icon>
            </div>
        </div>
        <mat-card
            appearance="outlined"
            class="mb-24 p-0 widget-card header-banner-stream mat-elevation-z0"
            *ngIf="stream.headerBannerStream"
            (click)="openEditAudienceWidgetDialog(stream.headerBannerStream.name, stream.headerBannerStream.featuredStreamId)"
        >
            <div class="widget-card-image-container">
                <div mat-card-avatar class="widget-card-image"></div>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <div fxLayout="row" fxLayoutAlign="start baseline">
                    <span class="experiance-name">{{ stream.headerBannerStream.experianceName | translate }}</span>
                    <h2 class="m-0">
                        {{ stream.headerBannerStream.name | translate }}
                    </h2>
                </div>

                <p class="mt-8 mb-0">{{ 'ENGAGE.WIDGET.TYPE.HEADER_BANNER_STREAM' | translate }}</p>
                <p class="my-0">{{ stream.headerBannerStream.description | translate }}</p>
            </mat-card-content>
            <mat-card-actions>
                <app-white-button [label]="'GENERAL.BUTTON.EDIT'"></app-white-button>
            </mat-card-actions>
        </mat-card>
        <mat-card
            appearance="outlined"
            class="widget-card featured-stream mb-12 p-0 mat-elevation-z0"
            *ngFor="let headerStream of stream.headerStream"
            (click)="openEditAudienceWidgetDialog(headerStream.name, headerStream.featuredStreamId)"
        >
            <div class="widget-card-image-container">
                <div mat-card-avatar class="widget-card-image"></div>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <span class="experiance-name">{{ headerStream.experianceName | translate }}</span>
                <div class="widgets-warning-container" fxLayout="row" fxLayoutAlign="start baseline">
                    <h2 class="m-0">{{ headerStream.name | translate }}</h2>
                </div>

                <p class="mt-8 mb-0">{{ 'ENGAGE.WIDGET.TYPE.HEADER_STREAM' | translate }}</p>
                <p class="my-0">{{ headerStream.description | translate }}</p>
            </mat-card-content>
            <mat-card-actions>
                <app-white-button [label]="'GENERAL.BUTTON.EDIT'"></app-white-button>
            </mat-card-actions>
        </mat-card>
        <mat-card
            appearance="outlined"
            class="p-0 mb-12 widget-card trending-courses mat-elevation-z0"
            *ngFor="let widget of widgets"
            (click)="openEditAudienceWidgetDialog(widget.name, widget.featuredStreamId)"
            [ngClass]="widget.type"
        >
            <div class="widget-card-image-container">
                <div mat-card-avatar class="widget-card-image"></div>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <span class="experiance-name">{{ widget.experianceName | translate }}</span>
                <div fxLayout="row" fxLayoutAlign="start baseline">
                    <h2 class="m-0">{{ widget.name | translate }}</h2>
                    <div class="widgets-warning-container" fxLayout="row" fxLayoutAlign="center center" *ngIf="widget.isWidgetEmpty">
                        <mat-icon
                            matTooltip="{{ 'ENGAGE.AUDIENCE.TOOLTIPS.EMPTY_WIDGET' | translate }}"
                            matTooltipPosition="right"
                            fxLayoutAlign="center center"
                            color="warn"
                            class="warning-icon"
                            >warning</mat-icon
                        >
                    </div>
                </div>
                <p class="mt-8 mb-0">{{ 'ENGAGE.WIDGET.TYPE.POSTING_STREAM' | translate }}</p>
                <p class="my-0">{{ widget.description | translate }}</p>
                <span class="count" *ngIf="widget.members"> {{ widget.members }} {{ 'ENGAGE.MEMBER.TITLE.PLURAL' | translate }} </span>
            </mat-card-content>
            <mat-card-actions>
                <app-white-button [label]="'GENERAL.BUTTON.EDIT'"></app-white-button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
